export default "__VITE_ASSET__BS1psfX4__"